var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-badge',{staticClass:"msg",attrs:{"value":_vm.msgUnread || ''}},[_c('i',{staticClass:"el-icon-message-solid msg-icon",on:{"click":_vm.toLookMsg}})])}
var staticRenderFns = []

export { render, staticRenderFns }